import Moment from 'moment';
import queryString from 'query-string';
import _ from 'lodash';
import { SUPPORTED_LANGUAGES } from './constants';

export function getLocalFromEmail(email = '') {
  return email.split('@')[0];
}

export function isDateInBetween(_startDate, _endDate) {
  const todayDate = Moment().toDate(); // today date
  const startDate = Moment(_startDate).toDate();
  const endDate = Moment(_endDate).toDate();

  return startDate <= todayDate && todayDate <= endDate;
}

export function convertSecondsToHMS(duration) {
  const hour = Math.floor(duration / 3600);
  const min = Math.floor((duration % 3600) / 60);
  const sec = Math.floor(duration % 3600 % 60);
  return { hour, min, sec };
}

export function getRemainingTimeLabel(hour, min, sec, intlConfig) {
  let timeLabel = '';

  if (hour) {
    timeLabel = hour > 1
      ? `${hour} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.hours })}`
      : `${hour} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.hour })}`;
  }

  if (min) {
    timeLabel = `${timeLabel}${min > 1
      ? `${min} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.minutes })}`
      : `${min} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.minute })}`}`;
  }

  return `${timeLabel}${sec !== 1
    ? `${sec} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.seconds })}`
    : `${sec} ${intlConfig.intl.formatMessage({ id: intlConfig.labels.second })}`}`;
}

export function parseHashString() {
  const hash = window.appHistory &&
    window.appHistory.location &&
    window.appHistory.location.hash;
  return queryString.parse(hash);
}

export function redirectTo(location, query) {
  let redirect = location;
  if (query) {
    redirect = `${location}${query}`;
  }
  setTimeout(() => window.appHistory.push(redirect));
}

export function checkCurrentPlan(planId = '', userPlanIds = []) {
  return _.includes(userPlanIds, planId);
}

export function hasSubscription(userPlans = []) {
  for (let index = 0; index < userPlans.length; index += 1) {
    const plan = userPlans[index];
    if (plan.daysRemaining > 0) {
      return true;
    }
  }
  return false;
}

export function hasMembership(userPlans = []) {
  let result = userPlans.map((plan) => {
    if (plan.planId.match(/membership/)) {
      return true;
    }
    return false;
  })

  return result.includes(true);
}

export function isAnyCurrentPlan(userPlanIds = [], plans = []) {
  for (let index = 0; index < plans.length; index += 1) {
    if (checkCurrentPlan(plans[index].planID, userPlanIds)) {
      return true;
    }
  }
  return false;
}

export function encodeObjectToB64(obj = {}) {
  const objJsonStr = JSON.stringify(obj);
  const objJsonB64 = btoa(objJsonStr);
  return objJsonB64;
}

export function decodeB64ToObject(b64String = '') {
  const objJsonString = atob(b64String);
  const object = JSON.parse(objJsonString);
  return object;
}

export function checkDateFormat(dateString, format = 'L') {
  return Moment(dateString, format, true).format(format) === dateString;
}

export function formatDate(dateString, format = 'L') {
  if (!dateString) {
    return false;
  }
  return Moment(dateString).format(format);
}

export function getDateDiff(dateTo, dateFrom = new Moment(), format = 'year') {
  const _dateTo = new Moment(dateTo);
  const _dateFrom = new Moment(dateFrom);
  return _dateFrom.diff(_dateTo, format);
}

export function removeCssClass(className = '') {
  const elements = document.getElementsByClassName(className);
  while (elements.length) {
    elements[0].classList.remove(className);
  }
}

export function removeKeyFromQueryParam(key) {
  let stringifiedQuery = '';
  const { search } = window.appHistory && window.appHistory.location;
  const parsedQuery = queryString.parse(search);
  delete parsedQuery[key];
  if (parsedQuery) {
    stringifiedQuery = `?${queryString.stringify(parsedQuery)}`;
  }
  return stringifiedQuery;
}

export function getLanguageFromBrowser(_locale) {
  const language = (window.navigator && window.navigator.languages && window.navigator.languages[0])
    || window.navigator.language;
  const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
  const locale = SUPPORTED_LANGUAGES.includes(languageWithoutRegionCode)
    ? languageWithoutRegionCode : _locale;
  return locale;
}

export function getLocaleStringForSupportLink(locale) {
  return locale === 'en' ? '' : `${locale}/`;
}

export default {
  getLocalFromEmail,
  isDateInBetween,
  parseHashString,
  getLanguageFromBrowser
};



// WEBPACK FOOTER //
// ./src/libs/common.js